import React from "react";

const LOGO_SRC = "/brand/site-logo.png";

export function BrandLogo({
  iconSize = 36,
  showText = true,
  textClassName = "text-base font-extrabold tracking-tight text-white",
  className = "flex items-center gap-2.5",
  testId = "brand-logo",
  plain = false, // when true: no lime glow on icon, no lime "BASE" highlight
}) {
  const imgClass = plain
    ? "shrink-0 rounded-[7px] object-contain"
    : "shrink-0 rounded-[7px] object-contain drop-shadow-[0_0_12px_rgba(200,255,0,0.22)]";
  return (
    <span data-testid={testId} className={className}>
      <img
        data-testid={`${testId}-image`}
        src={LOGO_SRC}
        alt="ClippingBase logo"
        className={imgClass}
        style={{ width: iconSize, height: iconSize }}
      />
      {showText ? (
        <span data-testid={`${testId}-text`} data-logo-lock="true" className={`${textClassName} brand-text`}>
          {plain ? (
            <>Clipping<span data-logo-lock="true">Base</span></>
          ) : (
            <>Clipping<span data-logo-lock="true" className="text-[#c8ff00]">Base</span></>
          )}
        </span>
      ) : null}
    </span>
  );
}

export const BRAND_LOGO_SRC = LOGO_SRC;
